
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><MDXTag name="h1" components={components} props={{"id":"ex-11---keyboard-shortcuts"}}>{`Ex. 11 - Keyboard Shortcuts`}</MDXTag>
<MDXTag name="h2" components={components} props={{"id":"instructions"}}>{`Instructions`}</MDXTag>
<MDXTag name="p" components={components}>{`Nous souhaitons maintenant créer un Hook permettant de réagir à un raccourcis clavier. Grâce à ce hook nous pourrons faire un focus sur le champs de recherche quand l'utilisateur appuie sur les touches "ALT" et "F" simultanément.`}</MDXTag>
<MDXTag name="p" components={components}>{`Pour réaliser un Hook aussi complexe, nous avons besoin de plusieurs choses :`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`Réagir aux évènements "keydown" et "keyup" de `}<MDXTag name="inlineCode" components={components} parentName="li">{`window`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Garder une trace des touches actives`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Déclencher une fonction lorsque les touches actives sont celles spécifiées dans le raccourcis`}</MDXTag>
</MDXTag>
<MDXTag name="p" components={components}>{`Nous allons donc décomposer le travail :`}</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"un-hook-useeventlistener"}}>{`Un Hook `}<MDXTag name="inlineCode" components={components} parentName="h3">{`useEventListener`}</MDXTag></MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-js"}}>{`function Example() {
  useEventListener(window, 'keydown', e => {
    console.log('A key is down:', e.keyCode)
  })
}
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"un-hook-useactivekeys"}}>{`Un Hook `}<MDXTag name="inlineCode" components={components} parentName="h3">{`useActiveKeys`}</MDXTag></MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-js"}}>{`function Example() {
  const activeKeys = useActiveKeys()
  // Affiche les touches enfoncées par l'utilisateur
  console.log(activeKeys)
}
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"une-fonction-getshortcutkeys"}}>{`Une fonction `}<MDXTag name="inlineCode" components={components} parentName="h3">{`getShortcutKeys`}</MDXTag></MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-js"}}>{`const shortcutKeys = getShortcutKeys('alt+f')
// [18, 70]
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"le-hook-useshortcuteffect"}}>{`Le Hook `}<MDXTag name="inlineCode" components={components} parentName="h3">{`useShortcutEffect`}</MDXTag></MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-js"}}>{`function Example() {
  useShortcutEffect('alt+f', () => {
    // La réaction au raccourcis "ALT" + "F"
  })
}
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"résultat-attendu"}}>{`Résultat attendu`}</MDXTag>
<MDXTag name="p" components={components}>{`Lorsque je presse les touches "ALT" et "F" simultanément, le champs de recherche est focus.`}</MDXTag>
<iframe
  src="https://codesandbox.io/embed/github/smooth-code/react-hooks-workshop/tree/end-exercise-11/?fontsize=14&view=preview"
  style={{
    width: '100%',
    height: 500,
    border: 0,
    borderRadius: 4,
    overflow: 'hidden',
  }}
  sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"
/>
<MDXTag name="h2" components={components} props={{"id":"aide"}}>{`Aide`}</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"utilisation-dune-fonction-dans-un-useeffect"}}>{`Utilisation d'une fonction dans un `}<MDXTag name="inlineCode" components={components} parentName="h3">{`useEffect`}</MDXTag></MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-js"}}>{`function useMountEffect(effect) {
  const effectRef = useRef()
  effectRef.current = effect

  useEffect(() => {
    effectRef.current()
  }, [effectRef])
}
`}</MDXTag></MDXTag>
           </MDXTag>
  }
}
  